// extracted by mini-css-extract-plugin
export default {"container":"Template_container__UltUG","region_search__wrapper":"Template_region_search__wrapper__Nc+id","region_search__close":"Template_region_search__close__8RCMv"};